import { AppState } from 'stores/index'
import { Popup as component } from './component'
import { connect } from 'react-redux'
import { branch, renderNothing } from 'recompose'
import { compose, Dispatch } from 'redux'
import { mapActiveMunicipality } from 'components/map/actions'
import { SyntheticEvent } from 'react'

const mapStateToProps = ({ popup, interactionCapabilities }: AppState) => {
  return {
    ...popup,
    useTouch: interactionCapabilities.touch
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    onCloseHandler: (event: SyntheticEvent<HTMLAnchorElement>) => {
      event.stopPropagation()
      dispatch(mapActiveMunicipality('-1'))
    }
  }
}

const renderNothingIfWrongActiveMunicipality = branch(
  ({ visible }) => !visible,
  renderNothing
)

const enhanceComponent = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  renderNothingIfWrongActiveMunicipality
)

export default enhanceComponent(component)
